import { listMediaCollectionEntries } from '@reelplicate/api-client/media-collections';
import type { MediaCollectionEntryDto } from '@reelplicate/api-client/model';
import { useQuery } from '@tanstack/react-query';

/** Invalidate with `[ENTRIES_KEY, workspaceId]` to refresh every collection's entries. */
export const ENTRIES_KEY = 'media-collection-entries';
const PAGE = 100;

/**
 * Everything a smart collection holds, as the server matches it, in its
 * order. A rule keeps at most 500 (1,000 without a cap), so this reads every
 * page.
 */
export function useCollectionEntries(
  workspaceId: string,
  collectionId: string | undefined,
  enabled: boolean,
) {
  return useQuery({
    queryKey: [ENTRIES_KEY, workspaceId, collectionId],
    enabled: enabled && Boolean(workspaceId && collectionId),
    queryFn: async ({ signal }) => {
      const entries: MediaCollectionEntryDto[] = [];
      let cursor: string | undefined;
      do {
        const page = await listMediaCollectionEntries(
          workspaceId,
          collectionId!,
          { limit: PAGE, ...(cursor ? { cursor } : {}) },
          signal,
        );
        entries.push(...page.items);
        cursor = page.nextCursor ?? undefined;
      } while (cursor);
      return entries;
    },
  });
}
